import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconContainer: {
      padding: theme.spacing(0.5)
    },
  })
);

export default useStyles;
